// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"327":"36cfa398","472":"b105616e","916":"487bb520"}[chunkId] + ".css";
};